import { render, staticRenderFns } from "./ModalConsignment.vue?vue&type=template&id=7060228a&scoped=true"
import script from "./ModalConsignment.vue?vue&type=script&lang=js"
export * from "./ModalConsignment.vue?vue&type=script&lang=js"
import style0 from "./ModalConsignment.vue?vue&type=style&index=0&id=7060228a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7060228a",
  null
  
)

export default component.exports